import { Component, ChangeDetectionStrategy, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { NavigationStart, Router, Event, RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '@shared/models/menu-item.model';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { toggleNavDemo } from './menu-mobile.animation';
import { MenuMobileHamburgerComponent } from './hamburger/hamburger.component';
import { SearchComponent } from '../../search/components/search/search.component';
import { MenuLanguagesComponent } from '../menu-languages/menu-languages.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [toggleNavDemo],
    imports: [RouterLink, MenuMobileHamburgerComponent, RouterLinkActive, SearchComponent, MenuLanguagesComponent, TranslatePipe, LocalizePipe],
})
export class MenuMobileComponent implements OnInit, OnDestroy {
    private router = inject(Router);

    @Input({ required: true }) menuItems!: MenuItem[];
    @Input({ required: true }) isMainPage!: boolean;
    @Input({ required: true }) compact!: boolean;

    mobileMenuShowing = false;

    private subscritpions = new Subscription();

    ngOnInit(): void {
        this.subscritpions.add(this.routeChangeEvent.subscribe());
    }

    ngOnDestroy(): void {
        this.subscritpions.unsubscribe();
    }

    toggleMenu(): void {
        this.mobileMenuShowing = !this.mobileMenuShowing;
    }

    closeMenu(): void {
        if (this.mobileMenuShowing) {
            this.mobileMenuShowing = false;
        }
    }

    /**
     * On Menu Item Click
     */
    itemClick(): void {
        this.closeMenu();
    }

    /**
     * Route Change Start EVent
     */
    get routeChangeEvent(): Observable<Event> {
        return this.router.events.pipe(
            filter((event) => event instanceof NavigationStart),
            tap(() => {
                this.closeMenu();
            }),
        );
    }
}
